module.exports = __webpack_public_path__ + "img/queuedUpload.e40e2bc3.svg";